export default from './CmsSidebarTabs';

export { TAB_DESIGN, TAB_LAYOUT } from './CmsSidebarTabs';
